// extracted by mini-css-extract-plugin
export default {"resize":"wrapper_resize__uSrYL","refit":"wrapper_refit__NKPV8"};